<template>
  <div class="main-container">
    <div class="product-body">
      <div style="padding: 30px 300px;text-align: left;">
        <h1 style="margin-top: 15px;text-align: center;">矩尺全栈智能流量管理平台</h1>
        <p style="text-indent: 2em;">矩尺全栈智能流量管理平台是基于分布式集群架构打造的国产一体化智能流量管理底座。采用高性能分布式架构，实现传统业务架构与 AI 原生应用的统一纳管；平台围绕应用交付、Web 应用网关、云原生流量引擎、AI 网关、统一负载均衡纳管等五大核心方向，为业务提供高效、稳定、安全的全场景流量治理和负载纳管能力。</p>
        <ul class="function-list">
          <li class="function-title">平台功能特点：</li>
          <li>
            <span class="function-label"><span>&#10004; </span>自主可控：</span>
            <span class="function-content">国产自研平台，中文GUI界面；</span>
          </li>
          <li>
            <span class="function-label"><span>&#10004; </span>分布式集群架构：</span>
            <span class="function-content">控制面与数据面解耦，分布式高可用架构，适应大规模集群和跨云统一管理需求；</span>
          </li>
          <li>
            <span class="function-label"><span>&#10004; </span>多环境兼容适配：</span>
            <span class="function-content">支持在物理机、虚拟化平台、私有云或公有云等环境部署；</span>
          </li>
          <li>
            <span class="function-label"><span>&#10004; </span>智能的流量调度：</span>
            <span class="function-content">利用丰富的负载均衡算法和调度策略，实现流量治理和业务灵活发布；</span>
          </li>
          <li>
            <span class="function-label"><span>&#10004; </span>支持SSL加解密：</span>
            <span class="function-content">支持SSL加密和卸载功能（国密/非国密）；</span>
          </li>
          <li>
            <span class="function-label"><span>&#10004; </span>多租户自助管理：</span>
            <span class="function-content">支持用户权限和负载资源的精细化管理，满足多云环境下多角色管理和使用需求；</span>
          </li>
          <li>
            <span class="function-label"><span>&#10004; </span>海量健康监测：</span>
            <span class="function-content">支持通过多协议和自定义脚本实现海量节点健康监测；</span>
          </li>
          <li>
            <span class="function-label"><span>&#10004; </span>多维度可观测运维 ：</span>
            <span class="function-content">支持自动生成虚拟服务拓扑和部署拓扑，支持多维度图形化流量和日志分析视图；</span>
          </li>
          <li>
            <span class="function-label"><span>&#10004; </span>灵活的告警和通知：</span>
            <span class="function-content">支持告警的灵活配置，支持邮件、脚本调用等通知方式；</span>
          </li>
          <li>
            <span class="function-label"><span>&#10004; </span>开放的接口：</span>
            <span class="function-content">支持标准OpenAPI，可与第三方安全平台联动；</span>
          </li>
        </ul>
      </div>
      <div style="border: 1px solid #bdd7ee;"></div>
      <!-- 产品介绍 -->
      <div style="padding: 50px 300px;text-align: left;" :id="curProduct.id">
        <h1 style="margin-top: 20px;margin-bottom: 20px;">{{ curProduct.title }}</h1>
        <h2 style="color:#1f4e79;margin-bottom: 20px;">{{ curProduct.subtitle }}</h2>
        <ul class="function-list">
          <li class="function-title">功能特点：</li>
          <li v-for="item in curProduct.items" :key="item.id">
            <span class="function-label"><span>&#10004; </span>{{ item.label }}</span>
            <span class="function-content">{{ item.desc }}</span>
          </li>
        </ul>
        <div style="padding-top: 30px;">
          <img :src="curProduct.img" width="777" :alt="curProduct.title">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductTitle from '@/components/ProductTitle.vue'
import TitlePoint from '@/components/TitlePoint.vue'

export default {
  components: {
    ProductTitle,
    TitlePoint
  },
  data() {
    return {
      productions: {
        normaeweb: {
          id: 'normaeweb',
          title: '矩尺Web智能网关',
          subtitle: '基于分布式集群架构的高性能Web应用网关， 是NGINX业务国产化替换方案；',
          items: [
            { label: '自主可控：', desc: '国产自研平台，中文GUI界面；' },
            { label: '分布式集群架构：', desc: '控制面与数据面解耦，分布式高可用架构，适应大规模集群和跨云统一管理需求；' },
            { label: '多环境兼容适配：', desc: '支持在物理机、虚拟化平台、私有云或公有云等环境部署；' }
          ],
          img: require('@/assets/imgs/product-center-normaeweb.png')
        },
        normaeapp: {
          id: 'normaeapp',
          title: '矩尺应用交付平台',
          subtitle: '基于分布式架构打造的通用应用负载均衡产品；',
          items: [
            { label: '全维度负载均衡与全局调度：', desc: '支持 4/7层全协议负载，内置高性能 DNS 解析（权威/递归）与静态就近性算法。通过全局负载均衡能力，实现多中心流量动态智能分配，确保跨地域访问的最佳体验。' },
            { label: '灵活的流量编排与策略管理：', desc: '通过多优先级分发策略与虚拟组等特性实现流量精准控制。灵活定义流量走向，完美支撑灰度发布、蓝绿部署等复杂业务切换场景。' },
            { label: '电信级可靠性与多维健康检查：', desc: '毫秒级健康检查，覆盖网络层至业务逻辑层的多维深度探测。配合多种高可用架构，确保业务连续性；支持软硬混合部署，一套界面即可实现跨平台、全场景的敏捷运维。' }
          ],
          img: require('@/assets/imgs/product-center-normaeapp.png')
        },
        normaecloud: {
          id: 'normaecloud',
          title: '矩尺云原生流量引擎',
          subtitle: '一款深度集成k8s，兼容标准Gateway API的可视化智能云原生流量治理引擎软件；',
          items: [
            { label: '深度集成 K8s 生态：', desc: '内置高性能 LoadBalancer 与 Gateway 模块，全方位覆盖集群南北向与东西向流量治理，完美适配云原生架构。' },
            { label: '物理与虚拟网络跨域互通：', desc: '支持 BGP 等动态路由协议，打通物理网络与 Pod 网络双向连接，实现容器化应用与传统业务的无缝平滑通信。' },
            { label: '全栈可视化管理与运维：', desc: '提供原生资源对象的图形化配置界面，支持基于流量状态的实时运行拓扑、全链路数据抓包及智能事件告警。' }
          ],
          img: require('@/assets/imgs/product-center-normaecloud.png')
        },
        normaeai: {
          id: 'normaeai',
          title: '矩尺AI网关',
          subtitle: '基于分布式集群架构的多模型容灾调度和高效运维智能网关；',
          items: [
            { label: '弹性多模型架构：', desc: '国产自研平台，中文GUI界面；' },
            { label: 'MCP 协议统一标准转换：', desc: '控制面与数据面解耦，分布式高可用架构，适应大规模集群和跨云统一管理需求；' },
            { label: '大模型安全合规使用：', desc: '从源头阻断提示词注入攻击和不当言论生成；实现敏感信息脱敏和合规处理，满足内容安全需求；' },
            { label: '多模型智能运维视图：', desc: '多维数据深度解构，如模型访问量、结束原因、Token消耗统计等运维视图，让复杂的 AI 业务可见、可控、可优化。' },
            { label: 'Web应用网关能力复用：', desc: '具备Web应用网关全功能；' }
          ],
          img: require('@/assets/imgs/product-center-normaeai.png')
        },
        normaeunified: {
          id: 'normaeunified',
          title: '矩尺统一纳管平台',
          subtitle: '一款多品牌负载均衡产品统一监控运维平台，支持主流负载均衡产品的统一监控和数据分析；',
          items: [
            { label: '统一监控：', desc: '国产自研平台，中文GUI界面；' },
            { label: '可视化运维：', desc: '支持自动生成虚拟服务拓扑、部署拓扑和业务流量分析图。' },
            { label: '业务关联分析：', desc: '支持通过标签关联业务名称，并聚合分析，可基于业务标签查询各项数据；' },
            { label: '报表生成：', desc: '支持对虚拟服务、服务器池、IP节点、负载等内容的报表生成和导出；' },
            { label: '异常发现并告警：', desc: '支持对异常事件以图像方式产生告警，并可自定义告警，实现与微信、短信等第三方平台联动；' }
          ],
          img: require('@/assets/imgs/product-center-normaeunified.png')
        },
      }
    }
  },
  computed: {
    curHash() {
      return (this.$route.hash || '#normaeweb').substring(1)
    },
    curProduct() {
      return this.productions[this.curHash] || this.productions.normaeweb
    }
  },
  mounted() {
    if (this.$route.hash) {
      const id = this.$route.hash.substring(1)
      const el = document.getElementById(id)
      if (el) {
        setTimeout(() => {
          el.scrollIntoView()
        }, 100);
      }
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '~@/assets/imgs/sprite.css';
.product-body {
  background-color: #fff;
}
.function-list{
  line-height: 2;
  .function-title{
    font-size: 18px;
    font-weight: bold;
  }
  .function-label{
    font-weight: bold;
  }
}
</style>